/**
 * Warrior Sol — Homepage Quick-Add Overlay v2.1
 * Enhances multicolumn product blocks with hover size selector + Add to Cart + Buy Now.
 * Now includes colorway swatch dots with image transitions.
 * Auto-detects product links, fetches variant data, integrates with cart drawer.
 * v2.1: Added "Buy Now" button for direct-to-checkout (Shop Pay, Apple Pay, etc.)
 */
(function() {
  'use strict';

  // Guard against multiple loads (multicolumn section appears multiple times)
  if (window.__wsQuickAddLoaded) return;
  window.__wsQuickAddLoaded = true;

  var PRODUCT_CACHE = {};

  // Color name → swatch background.
  // FIX 2026-06-22: the hat colorways were color-matched directly from the real product
  // photos (screen color comparison off the actual caps). The two-tone "A + B" names now
  // render a diagonal split of both real fabric colors; single colors stay solid hex.
  var COLOR_MAP = {
    'sunshine yellow': '#F8B706',
    'midnight': '#2A3A4D',
    'midnight blue': '#303F57',
    'coconut white': '#EDECED',
    'snow white': '#E8E5E2',
    'sky blue': '#8CB0CF',
    'sky + snow': 'linear-gradient(135deg, #A7C9DD 50%, #F3F1EB 50%)',
    'cloud gray': '#6B6C6E',
    'slate gray': '#868685',
    'moon gray': '#C7C8C4',
    'moon + snow': 'linear-gradient(135deg, #ADA593 50%, #EFEDE6 50%)',
    'carbon black': '#252526',
    'moss green': '#89A253',
    'berry red': '#75061D',
    'autumn + charcoal': 'linear-gradient(135deg, #45474A 50%, #B16A39 50%)',
    'sand + shell': 'linear-gradient(135deg, #D6C6AB 50%, #EEE7D8 50%)'
  };

  function init() {
    var columns = document.querySelectorAll('.multicolumn-list__item');
    var productHandles = [];

    columns.forEach(function(col) {
      var link = col.querySelector('a[href*="/products/"]');
      if (!link) return;

      var href = link.getAttribute('href');
      var handle = href.split('/products/')[1].split('?')[0].split('#')[0];
      var titleEl = col.querySelector('.multicolumn-card__info h3');
      var colorName = titleEl ? titleEl.textContent.trim() : '';

      col.dataset.productHandle = handle;
      col.dataset.colorName = colorName;

      if (productHandles.indexOf(handle) === -1) {
        productHandles.push(handle);
      }

      createOverlay(col);
    });

    // Prefetch all unique products
    productHandles.forEach(function(handle) {
      fetchProduct(handle);
    });
  }

  function fetchProduct(handle) {
    if (PRODUCT_CACHE[handle]) {
      populateOverlays(handle, PRODUCT_CACHE[handle]);
      return;
    }

    fetch('/products/' + handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(product) {
        PRODUCT_CACHE[handle] = product;
        populateOverlays(handle, product);
      })
      .catch(function(err) {
        console.error('WS Quick-Add: Failed to fetch', handle, err);
      });
  }

  function createOverlay(col) {
    var imageWrapper = col.querySelector('.multicolumn-card__image-wrapper');
    if (!imageWrapper) return;

    imageWrapper.style.position = 'relative';

    var overlay = document.createElement('div');
    overlay.className = 'ws-quick-add-overlay';
    overlay.innerHTML =
      '<div class="ws-qa-inner">' +
        '<div class="ws-qa-header">' +
          '<span class="ws-qa-product-name"></span>' +
          '<span class="ws-qa-product-price"></span>' +
        '</div>' +
        '<div class="ws-qa-swatches"></div>' +
        '<div class="ws-qa-sizes">' +
          '<div class="ws-qa-size-label">Select Size</div>' +
          '<div class="ws-qa-size-buttons"></div>' +
        '</div>' +
        '<div class="ws-qa-btn-row">' +
          '<button class="ws-qa-add-btn" disabled>' +
            '<span class="ws-qa-text-default">Add to Cart</span>' +
            '<span class="ws-qa-text-adding" style="display:none">Adding...</span>' +
            '<span class="ws-qa-text-added" style="display:none">Added!</span>' +
          '</button>' +
          '<button class="ws-qa-buy-now-btn" disabled>' +
            '<span class="ws-qa-buy-default">Buy Now</span>' +
            '<span class="ws-qa-buy-processing" style="display:none">Going...</span>' +
          '</button>' +
        '</div>' +
      '</div>';

    imageWrapper.appendChild(overlay);

    // Click handling within overlay
    overlay.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      // Swatch dot click
      var swatchDot = e.target.closest('.ws-qa-swatch-dot');
      if (swatchDot) {
        handleSwatchClick(col, swatchDot);
        return;
      }

      var sizeBtn = e.target.closest('.ws-qa-size-btn');
      if (sizeBtn && !sizeBtn.disabled) {
        overlay.querySelectorAll('.ws-qa-size-btn').forEach(function(b) {
          b.classList.remove('selected');
        });
        sizeBtn.classList.add('selected');
        // Enable BOTH buttons and set variant ID on both
        var addBtn = overlay.querySelector('.ws-qa-add-btn');
        var buyBtn = overlay.querySelector('.ws-qa-buy-now-btn');
        addBtn.disabled = false;
        addBtn.dataset.variantId = sizeBtn.dataset.variantId;
        buyBtn.disabled = false;
        buyBtn.dataset.variantId = sizeBtn.dataset.variantId;
        return;
      }

      var addBtn = e.target.closest('.ws-qa-add-btn');
      if (addBtn && !addBtn.disabled) {
        addToCart(addBtn);
        return;
      }

      var buyBtn = e.target.closest('.ws-qa-buy-now-btn');
      if (buyBtn && !buyBtn.disabled) {
        buyNow(buyBtn);
        return;
      }
    });
  }

  function handleSwatchClick(col, swatchDot) {
    var overlay = col.querySelector('.ws-quick-add-overlay');
    var newColor = swatchDot.dataset.colorName;
    var handle = col.dataset.productHandle;
    var product = PRODUCT_CACHE[handle];
    if (!product) return;

    // Update active state on swatch dots
    overlay.querySelectorAll('.ws-qa-swatch-dot').forEach(function(d) {
      d.classList.remove('active');
    });
    swatchDot.classList.add('active');

    // Update stored color name
    col.dataset.colorName = newColor;

    // Find the featured image for this colorway
    var colorIdx = getOptionIndex(product, 'color');
    if (colorIdx >= 0) {
      var matchingVariant = product.variants.find(function(v) {
        return v.options[colorIdx] === newColor && v.featured_image;
      });

      if (matchingVariant && matchingVariant.featured_image) {
        swapCardImage(col, matchingVariant.featured_image.src);
      }
    }

    // Re-populate size buttons for the new color
    repopulateSizes(col, product);

    // Reset BOTH buttons
    var addBtn = overlay.querySelector('.ws-qa-add-btn');
    var buyBtn = overlay.querySelector('.ws-qa-buy-now-btn');
    addBtn.disabled = true;
    addBtn.dataset.variantId = '';
    buyBtn.disabled = true;
    buyBtn.dataset.variantId = '';
    overlay.querySelectorAll('.ws-qa-size-btn').forEach(function(b) {
      b.classList.remove('selected');
    });
  }

  function swapCardImage(col, newSrc) {
    var img = col.querySelector('.multicolumn-card__image-wrapper img');
    if (!img) return;

    // Add transition class
    img.classList.add('ws-image-transitioning');

    // After fade out, swap src
    setTimeout(function() {
      // Build responsive srcset from the new image URL
      var baseSrc = newSrc.replace(/\?.*$/, '');
      img.src = baseSrc + '?width=535&height=535&crop=center';
      img.srcset = baseSrc + '?width=165 165w, ' +
        baseSrc + '?width=360 360w, ' +
        baseSrc + '?width=535 535w, ' +
        baseSrc + '?width=750 750w';

      // Remove transition class after image loads
      img.onload = function() {
        img.classList.remove('ws-image-transitioning');
      };
      // Fallback: remove class after timeout
      setTimeout(function() {
        img.classList.remove('ws-image-transitioning');
      }, 400);
    }, 150);
  }

  function getOptionIndex(product, optionName) {
    var idx = -1;
    product.options.forEach(function(opt, i) {
      var name = (typeof opt === 'string') ? opt : (opt.name || '');
      var lower = name.toLowerCase();
      if (lower === optionName || (optionName === 'color' && lower === 'colour')) idx = i;
    });
    return idx;
  }

  function repopulateSizes(col, product) {
    var overlay = col.querySelector('.ws-quick-add-overlay');
    var colorName = col.dataset.colorName;
    var colorIdx = getOptionIndex(product, 'color');
    var sizeIdx = getOptionIndex(product, 'size');
    var sizesDiv = overlay.querySelector('.ws-qa-sizes');
    var sizeButtons = overlay.querySelector('.ws-qa-size-buttons');
    var addBtn = overlay.querySelector('.ws-qa-add-btn');
    var buyBtn = overlay.querySelector('.ws-qa-buy-now-btn');

    var uniqueColors = getUniqueColors(product, colorIdx);

    // Get matching variants for this color
    var matchingVariants;
    if (colorIdx >= 0 && uniqueColors.length > 1) {
      matchingVariants = product.variants.filter(function(v) {
        return v.options[colorIdx] === colorName;
      });
    } else {
      matchingVariants = product.variants;
    }

    if (matchingVariants.length === 0) {
      sizeButtons.innerHTML = '<span class="ws-qa-unavailable">Unavailable</span>';
      return;
    }

    // If only one variant or no size option: skip size selector
    if (sizeIdx < 0 || matchingVariants.length === 1) {
      sizesDiv.style.display = 'none';
      addBtn.disabled = false;
      addBtn.dataset.variantId = matchingVariants[0].id;
      buyBtn.disabled = false;
      buyBtn.dataset.variantId = matchingVariants[0].id;
      return;
    }

    sizesDiv.style.display = '';

    // Sort by standard size order
    var sizeOrder = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', 'One Size'];
    matchingVariants.sort(function(a, b) {
      var ai = sizeOrder.indexOf(a.options[sizeIdx]);
      var bi = sizeOrder.indexOf(b.options[sizeIdx]);
      if (ai === -1) ai = 99;
      if (bi === -1) bi = 99;
      return ai - bi;
    });

    // Build size buttons
    sizeButtons.innerHTML = matchingVariants.map(function(v) {
      var size = v.options[sizeIdx];
      var avail = v.available;
      return '<button class="ws-qa-size-btn' + (avail ? '' : ' sold-out') + '" ' +
        'data-variant-id="' + v.id + '" ' +
        (avail ? '' : 'disabled ') +
        'title="' + (avail ? size : size + ' - Sold Out') + '">' +
        size + '</button>';
    }).join('');
  }

  function getUniqueColors(product, colorIdx) {
    var uniqueColors = [];
    if (colorIdx >= 0) {
      product.variants.forEach(function(v) {
        if (uniqueColors.indexOf(v.options[colorIdx]) === -1) {
          uniqueColors.push(v.options[colorIdx]);
        }
      });
    }
    return uniqueColors;
  }

  function populateOverlays(handle, product) {
    var cols = document.querySelectorAll('[data-product-handle="' + handle + '"]');

    var colorIdx = getOptionIndex(product, 'color');
    var sizeIdx = getOptionIndex(product, 'size');

    // Get unique colors
    var uniqueColors = getUniqueColors(product, colorIdx);

    cols.forEach(function(col) {
      var colorName = col.dataset.colorName;
      var overlay = col.querySelector('.ws-quick-add-overlay');
      if (!overlay) return;

      // Populate product name and price
      var nameEl = overlay.querySelector('.ws-qa-product-name');
      var priceEl = overlay.querySelector('.ws-qa-product-price');
      if (nameEl) nameEl.textContent = product.title;
      if (priceEl) {
        var price = (product.price / 100).toFixed(2);
        priceEl.textContent = '$' + price;
      }

      // Build swatch dots if product has multiple colors
      var swatchesDiv = overlay.querySelector('.ws-qa-swatches');
      if (uniqueColors.length > 1 && colorIdx >= 0) {
        var swatchHTML = uniqueColors.map(function(color) {
          var hex = COLOR_MAP[color.toLowerCase()] || '#999';
          var isActive = (color === colorName) ? ' active' : '';
          return '<button class="ws-qa-swatch-dot' + isActive + '" ' +
            'data-color-name="' + color + '" ' +
            'title="' + color + '" ' +
            'style="background: ' + hex + ';">' +
            '</button>';
        }).join('');
        swatchesDiv.innerHTML = swatchHTML;
        swatchesDiv.style.display = '';
      } else {
        swatchesDiv.style.display = 'none';
      }

      var sizesDiv = overlay.querySelector('.ws-qa-sizes');
      var sizeButtons = overlay.querySelector('.ws-qa-size-buttons');
      var addBtn = overlay.querySelector('.ws-qa-add-btn');
      var buyBtn = overlay.querySelector('.ws-qa-buy-now-btn');

      // Get matching variants for this color
      var matchingVariants;
      if (colorIdx >= 0 && uniqueColors.length > 1) {
        matchingVariants = product.variants.filter(function(v) {
          return v.options[colorIdx] === colorName;
        });
      } else {
        matchingVariants = product.variants;
      }

      if (matchingVariants.length === 0) {
        sizeButtons.innerHTML = '<span class="ws-qa-unavailable">Unavailable</span>';
        return;
      }

      // If only one variant or no size option: skip size selector
      if (sizeIdx < 0 || matchingVariants.length === 1) {
        sizesDiv.style.display = 'none';
        addBtn.disabled = false;
        addBtn.dataset.variantId = matchingVariants[0].id;
        buyBtn.disabled = false;
        buyBtn.dataset.variantId = matchingVariants[0].id;
        return;
      }

      // Sort by standard size order
      var sizeOrder = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', 'One Size'];
      matchingVariants.sort(function(a, b) {
        var ai = sizeOrder.indexOf(a.options[sizeIdx]);
        var bi = sizeOrder.indexOf(b.options[sizeIdx]);
        if (ai === -1) ai = 99;
        if (bi === -1) bi = 99;
        return ai - bi;
      });

      // Build size buttons
      sizeButtons.innerHTML = matchingVariants.map(function(v) {
        var size = v.options[sizeIdx];
        var avail = v.available;
        return '<button class="ws-qa-size-btn' + (avail ? '' : ' sold-out') + '" ' +
          'data-variant-id="' + v.id + '" ' +
          (avail ? '' : 'disabled ') +
          'title="' + (avail ? size : size + ' - Sold Out') + '">' +
          size + '</button>';
      }).join('');
    });
  }

  function addToCart(btn) {
    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    var textDefault = btn.querySelector('.ws-qa-text-default');
    var textAdding = btn.querySelector('.ws-qa-text-adding');
    var textAdded = btn.querySelector('.ws-qa-text-added');

    textDefault.style.display = 'none';
    textAdding.style.display = '';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId), quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble'
      })
    })
    .then(function(r) {
      if (!r.ok) throw new Error('Add to cart failed');
      return r.json();
    })
    .then(function(data) {
      textAdding.style.display = 'none';
      textAdded.style.display = '';

      // Open cart drawer with fresh section data
      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(data);
      } else {
        // Fallback: just update the cart bubble
        updateCartBubble();
      }

      // Reset button after delay
      setTimeout(function() {
        textAdded.style.display = 'none';
        textDefault.style.display = '';
        btn.disabled = false;
      }, 2500);
    })
    .catch(function(err) {
      console.error('WS Quick-Add: Cart error', err);
      textAdding.style.display = 'none';
      textDefault.style.display = '';
      textDefault.textContent = 'Try Again';
      btn.disabled = false;
      setTimeout(function() {
        textDefault.textContent = 'Add to Cart';
      }, 2000);
    });
  }

  /**
   * Buy Now — add to cart then redirect straight to checkout.
   * Shopify checkout will show Shop Pay, Apple Pay, Google Pay, etc.
   * Fastest path from "I want this" to "take my money."
   */
  function buyNow(btn) {
    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    var textDefault = btn.querySelector('.ws-qa-buy-default');
    var textProcessing = btn.querySelector('.ws-qa-buy-processing');

    textDefault.style.display = 'none';
    textProcessing.style.display = '';
    btn.disabled = true;

    // Also disable the Add to Cart button so they can't double-tap
    var addBtn = btn.closest('.ws-qa-btn-row').querySelector('.ws-qa-add-btn');
    if (addBtn) addBtn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId), quantity: 1 }]
      })
    })
    .then(function(r) {
      if (!r.ok) throw new Error('Add to cart failed');
      return r.json();
    })
    .then(function() {
      // Straight to checkout — Shop Pay, Apple Pay, Google Pay all live here
      window.location.href = '/checkout';
    })
    .catch(function(err) {
      console.error('WS Quick-Add: Buy Now error', err);
      textProcessing.style.display = 'none';
      textDefault.style.display = '';
      textDefault.textContent = 'Try Again';
      btn.disabled = false;
      if (addBtn) addBtn.disabled = false;
      setTimeout(function() {
        textDefault.textContent = 'Buy Now';
      }, 2000);
    });
  }

  function updateCartBubble() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var bubbles = document.querySelectorAll('.cart-count-bubble span[aria-hidden]');
        bubbles.forEach(function(el) { el.textContent = cart.item_count; });
        var srBubbles = document.querySelectorAll('.cart-count-bubble .visually-hidden');
        srBubbles.forEach(function(el) {
          el.textContent = cart.item_count + (cart.item_count !== 1 ? ' items' : ' item');
        });
        var bubble = document.querySelector('.cart-count-bubble');
        if (bubble) bubble.removeAttribute('hidden');
      });
  }

  // Initialize after DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
